<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image
            class="img"
            :src="$t('menu.TheReportQueryImg')"
            alt=""
          ></el-image>
        </el-container>
      </el-col>
    </el-row>
    <div class="content">
      <el-row>
        <el-col :span="7">
          <Content>
            <template #MingChen>
              <div>{{ $t("menu.customer") }}</div>
            </template>

            <template #ContentEr>
              <div class="inlineer">
                <li>
                  <router-link to="/CustomerInspection">
                    <div>{{ $t("menu.Instructions") }}</div></router-link>
                </li>
              </div>
            </template>

            <template #ContentSan>
              <div class="inlineer">
                <li>
                  <router-link to="/TestApplicationForm">
                    <div>{{ $t("menu.Testapplicationform") }}</div></router-link
                  >
                </li>
              </div>
            </template>
            <template #ContentSi>
              <div class="inlineer">
                <li>
                  <router-link to="/TheReportQuery">
                    <div style="color: #1d2088">
                      {{ $t("menu.TheReportQuery") }}
                    </div>
                  </router-link>
                </li>
              </div>
            </template>
            <template #ContentWu>
              <div class="inlineer">
                <li>
                  <router-link to="/TheInspectionProcess"
                    ><div>
                      {{ $t("menu.TheInspectionProcess") }}
                    </div></router-link
                  >
                </li>
              </div>
            </template>
          </Content>
        </el-col>
        <el-col :span="17">
          <div class="inline">
            <el-divider direction="vertical"></el-divider>
            <h3 class="Xjiao">{{ $t("menu.TheReportQuery") }}</h3>
          </div>
          <div class="fff">
            <el-form
              status-icon
              :model="ruleForm"
              ref="ruleForm"
              class="demo-ruleForm"
            >
              <!-- :model="ruleForm"    :rules="rules" -->
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item :label="$t('menu.reportNumber')">
                    <el-input v-model="ruleForm.name"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row class="details">
                <el-form-item>
                  <el-button size="mini" round @click="SelectBtn()">{{
                    $t("menu.Select")
                  }}</el-button>
                  <el-button size="mini" @click="resetForm()" round>{{
                    $t("menu.reset")
                  }}</el-button>
                </el-form-item>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-divider class="divider" ></el-divider>
                </el-col>
              </el-row>
            </el-form>

            <el-row>
              <el-col :span="24">
                <span style="color: #1d2088;margin-top:0px">
                  {{ $t("menu.ReportFiles") }}
                </span>
              </el-col>
            </el-row>

            <el-row class="right">
              <el-col
                :span="8"
                v-for="(item, index) in ProjectList"
                :key="index"
              >
                <ul class="ul">
                  <li>{{ index + 1 }}）</li>
                  <!-- <div  > -->

                  <li>{{ $t("menu.tel") }}{{ item.name }}</li>
                  <li>{{ $t("menu.tel") }} {{ item.tel }}</li>
                  <li>{{ $t("menu.fax") }} {{ item.fax }}</li>
                  <li>{{ $t("menu.mailbox") }} {{ item.mailbox }}</li>

                  <!-- </div> -->
                </ul>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 对话框 -->

    <el-dialog :visible.sync="dialogVisible">
      <div class="inline">
        <el-divider direction="vertical"></el-divider>
        <h3 class="Xjiao">{{ $t("menu.searchResult") }}</h3>
      </div>
      <div class="padding">
        <el-row v-if="this.Select.length === 0">
          <el-col :span="18" :offset="3">
            <span class="mar"> {{ $t("menu.inputError") }}</span>
          </el-col>
        </el-row>
        <div
          v-for="(itemer, indexer) in Select"
          :key="indexer"
          style="marign-bottom: 50px"
        >
          <span>{{ $t("menu.reportNumber") }}：{{ itemer.reportNo }} </span>
        
          <span> {{ $t("menu.sampleName") }}{{ itemer.productName }} </span>
          <span> {{ $t("menu.testItemer") }}{{ itemer.model }} </span>
           <span> {{ $t("menu.JianCeBiaoZhun") }} {{ itemer.standard }} </span>
          <span>
            {{ $t("menu.testingResult") }}{{ itemer.result }}
          </span>
            <span> {{ $t("menu.applicationDate") }} {{ itemer.createDate }} </span>
          <span> {{ $t("menu.TestCompletionDate") }} {{ itemer.remarks }}</span>
        </div>
        <el-row> 
          <el-col :span="6" :offset="9">
            <el-button class="Btn-primary" round @click="dialogVisible = false">
              {{ $t("menu.confirm") }}</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <!-- 底部 -->
    <MyFooter> </MyFooter>
  </div>
</template>

  
<style  lang="scss" scoped>
.divider{
  background: #eeeeee;
}
.mar {
  // margin-bottom: 50px;
  color: #ff0000;
  font-size: 24px;
}
.padding {
  padding: 10px 30px;
}
.Btn-primary {
  margin-top: 50px;
}
/deep/ .el-dialog__body {
  padding: 0px;
}
/deep/ .el-form {
  padding: 0px 20px;
}
/deep/ .el-dialog__header {
  padding: 0px;
}
/deep/ .el-dialog {
  width: 556px;
  // height: 690px;
}
.el-button--small {
  background: #eeeeee;
}
.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
}
.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.conta {
  margin-top: 161px;
}
.SanJiao {
  position: relative;
  bottom: 40px;
  left: 228px;
}

.shisi {
  font-size: 14px;
  background: #ffffff;
  padding: 10px;
  padding-left: 20px;
}
.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.divider {
  background-color: #eeeeee;
}
.fff {
  background: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
  padding-top: 0px;
}

a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
a:-webkit-any-link:focus,
a:-webkit-any-link:hover {
  color: #1d2088;
}
span {
  display: block;

  font-weight: 400;
  font-size: 16px;
  margin-top: 20px;
  // color: #1d2088;
}
/deep/ .el-form-item__label {
  font-size: 20px;
  color: #333333;
}
.el-form-item {
  margin-bottom: 0px;
}

.ul li {
  list-style: none;
  line-height: 40px;
  font-size: 12px;
  color: #666666;
}
.right li:first-child {
  position: relative;
  right: 30px;
  line-height: 10px;
}
</style>

<script>
export default {
  name: "TheReportQuery",

  data() {
    return {
      number: "5-3",

      ProjectList: [],
      Select: [],
      dialogVisible: false,
      ruleForm: {
        name: "",
      },
    };
  },
  created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    this.getSelectRubber();
  },
  methods: { 
    async getSelectRubber() {
      const { data: res } = await this.$http.get("/Service/GetSalesman", {
        params: { languageType: this.title },
      });

      if (res.code !== 200) return console.log("数据请求失败! ");

      this.ProjectList = res.data;
      // console.log(this.ProjectList)
    },
    // 查询
    async SelectBtn() {
      const { data: res } = await this.$http.get("/Service/GetReport", {
        params: { reportNo: this.ruleForm.name, languageType: this.title },
      });

      if (res.code !== 200) return console.log("数据请求失败! ");

      this.Select = res.data;
      console.log(this.Select);

      this.dialogVisible = true;
    },

    // 重置按钮
    resetForm() {
      this.ruleForm.name = "";
      // this.ruleForm.archive="";
    },
  },
};
</script>